import styled from "styled-components";

import goTo from "../../controllers/goTo.js";
import { useContext } from "react";
import Context from "../../Context.js";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--accent);
  text-transform: uppercase;
  padding-left: 25px;
  margin-top: -10px;
  gap: 5px;
`;

const Line1 = styled.div`
  font-size: 21px;
  font-weight: 900;

  @media (max-width: 1300px) {
    font-size: 15px;
  }
`;

const Line2 = styled.div`
  font-size: 18px;
  font-weight: 700;

  @media (max-width: 1300px) {
    font-size: 11px;
  }
`;

export default function BrandContainerJustText({ style }) {
  const { themeState } = useContext(Context);
  window.goTo = goTo;

  return (
    <Container style={style}>
      <Line1>Continental</Line1>
      <Line2>Security</Line2>
    </Container>
  );
}
